import { render, staticRenderFns } from "./content-creator.vue?vue&type=template&id=59bc635e&scoped=true"
import script from "./content-creator.vue?vue&type=script&lang=js"
export * from "./content-creator.vue?vue&type=script&lang=js"
import style0 from "./content-creator.vue?vue&type=style&index=0&id=59bc635e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc635e",
  null
  
)

export default component.exports